import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type {
  SignAllAttendanceSheetsBody,
  SignAllAttendanceSheetsResponse,
} from "@shared-kernel/application/ports/student/student-repository";

export const signAllStudentAttendanceSheets = createAsyncThunk<
  SignAllAttendanceSheetsResponse,
  SignAllAttendanceSheetsBody,
  { extra: Partial<Dependencies> }
>("student/signAllAttendanceSheets", async (payload: SignAllAttendanceSheetsBody, { extra: { studentRepository } }) => {
  return studentRepository!.signAllAttendanceSheets(payload);
});
